<template>
    <div class="info-card bank-account-display">
    <b-card class="d-flex flex-column">
        <h2 class="underlined-heading">
            <span>
                <i class="inticon-documents"/>
                {{ headline }}
            </span>
            <span></span>
        </h2>
        <b-row>
            <b-col cols="6">
                <div class="info-card-element">
                    <label>Kontoinhaber</label>
                    <span class="value">{{ bankAccountAttributes.depositor }}</span>
                </div>
            </b-col>
            <b-col cols="6">
                <div class="info-card-element">
                    <label>IBAN</label>
                    <span class="value">{{ bankAccountAttributes.iban }}</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <div class="info-card-element">
                    <label>Bankname</label>
                    <span class="value">{{ bankAccountAttributes.bankName }}</span>
                </div>
            </b-col>
            <b-col cols="6">
                <div class="info-card-element">
                    <label>BIC</label>
                    <span class="value">{{ bankAccountAttributes.bic }}</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <div class="info-card-element">
                    <label>PLZ der Bank</label>
                    <span class="value">{{ bankAccountAttributes.postalCode }}</span>
                </div>
            </b-col>
            <b-col cols="6">
                <div class="info-card-element">
                    <label>Ort der Bank</label>
                    <span class="value">{{ bankAccountAttributes.place }}</span>
                </div>
            </b-col>
        </b-row>
    </b-card>
    </div>
</template>

<script>
    export default {
        name: 'CostUnitBankAccount',
        props: {
            bankAccount: {
                type: Object,
                required: true,
            },
            headline: {
                type: String,
                required: true,
                default: 'Bankverbindung',
            },
        },
        computed: {
            bankAccountAttributes() {
                return this.bankAccount.attributes || {};
            },
        },
    }
</script>
